import { workspaceModel } from 'APP/model/model';

export async function promoteAdminToWorkspace(userIds: string[]): Promise<boolean> {
  try {
    await workspaceModel.promoteToAdmin(userIds);

    return true;
  } catch {
    return false;
  }
}
